export const styles = {
  wrapper: {
    height: 72,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: "'Proxima Nova', sans-serif",
    boxShadow: '0px 2px 14px rgba(39, 55, 84, 0.08)',
    background: '#F9F9FF',
    position: 'relative',
    zIndex: 1,
  },
  main: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    padding: '0 24px',
  },
  user: {
    display: 'flex',
    alignItems: 'center',
    padding: '4px 10px',
    borderRadius: '8px',
    cursor: 'pointer',
    '&:hover': {
      background: '#E2E2FC',
    },
    minWidth: '162px',
  },
  names: {
    marginLeft: '8px',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  clientName: {
    color: '#011533',
    fontWeight: 700,
    fontSize: '14px',
  },
  userName: {
    color: '#011533',
    fontWeight: 400,
    fontSize: '14px',
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  userPicture: {
    borderRadius: '50%',
    overflow: 'hidden',
    height: '32px',
    width: '32px',
    '& img': {
      height: '32px',
      width: '32px',
      objectFit: 'cover',
      objectPosition: 'center',
    },
  },
  arrow: {
    marginLeft: '4px',
    height: '7px',
  },
  popoverWrapper: {
    display: 'flex',
    flexDirection: 'column',
    padding: '10px 0',
  },
  item: {
    padding: '8px 22px',
    cursor: 'pointer',
    display: 'flex',
    // alignItems: 'center',
    width: '165px',
    '&:hover': {
      background: '#E2E2FC',
    },
  },
  open: {
    background: '#E2E2FC',
  },
  title: {
    marginLeft: '12px',
    color: '#00112B',
    fontWeight: 700,
  },
  rotate: {
    transform: 'rotate(180deg)',
    transitionDuration: '0.2s',
  },
}
